import React from 'react';

import { styled } from '@mui/material';

export const ModelIntroText = ({
  headline,
  body,
  className = '',
}: {
  headline: string | null;
  body: string | null;
  className?: string;
}) => (
  <>
    <IntroTextHeadline className={className}>{headline}</IntroTextHeadline>
    <IntroTextParagraph>
      <div dangerouslySetInnerHTML={{ __html: body ?? '' }}></div>
    </IntroTextParagraph>
  </>
);

const IntroTextHeadline = styled('h3')(({ theme }) => ({
  ...theme.typography.h2,
  marginTop: '24px',
  marginBottom: '25px',

  [theme.breakpoints.down('sm')]: {
    marginTop: '44px',
    marginBottom: '30px',
    width: '95%',
  },
}));

const IntroTextParagraph = styled('div')(({ theme }) => ({
  ...theme.typography.body,
  margin: 0,

  [theme.breakpoints.down('sm')]: {
    width: '95%',
  },
}));
